import {
  DocumentOrganizationKeys,
  FilterDocument,
  FilterOptionKeys,
} from 'shared/types/filter-document';
import { LifeArea } from 'shared/types/life-area';
import { GroupByMode, SortingMode } from 'shared/types/sorting-mode';

export const getDefaultFilterDocument = (
  lifeArea?: LifeArea,
): FilterDocument => ({
  [DocumentOrganizationKeys.GroupByMode]: GroupByMode.Section,
  [DocumentOrganizationKeys.SortingMode]: SortingMode.Custom,
  [DocumentOrganizationKeys.Filters]: {
    [FilterOptionKeys.LifeArea]: { include: [lifeArea?.id ?? ''] },
  },
});
